import { Component, Input } from '@angular/core';
import { OrganizationLink } from 'src/app/swagger-api';

@Component({
  selector: 'app-role-navigation-organization',
  templateUrl: './role-navigation-organization.component.html',
  styleUrls: ['./role-navigation-organization.component.scss'],
})
export class RoleNavigateToOrganizationComponent {
  @Input({ required: true }) public organizationLinkUrlParams: OrganizationLink[] = [];
}
